// extracted by mini-css-extract-plugin
export default {"inner":"screen_inner__RziVp","toastZone":"screen_toastZone__Bi-Yq","title":"screen_title__ep-KM"};